import { render, staticRenderFns } from "./duzelt.vue?vue&type=template&id=440d4d54"
import script from "./duzelt.vue?vue&type=script&lang=js"
export * from "./duzelt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports